import { Application } from 'common/src/services';
import { IWhitePaper } from '../interface/pageData';

class AppService extends Application<IWhitePaper> {}
const templateData = Application.getTemplateData();
const data = templateData.data;
const config = templateData.config;
const pageData: IWhitePaper = {
    Lang: config.lang,
    SYSTEM: config.system,
    siteHost: config.site_host,
    userInfo: data.user_info,
    contextInfo: data.context_info,
    refer_url: data.refer_url,
};

// tslint:disable-next-line:no-console
console.log(pageData);

const appService = new AppService(pageData);
const getAppData = appService.getData;
export default appService;
export { getAppData };
